import { useState } from "react";
import { Phone, Clock, Shield, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import heroImage from "@/assets/serrurier-hero.jpg";
import { CallbackForm } from "@/components/CallbackForm";

const Hero = () => {
  const [callbackOpen, setCallbackOpen] = useState(false);

  return (
    <section className="relative text-white pt-32 pb-20 overflow-hidden">
      {/* Image de fond */}
      <div className="absolute inset-0">
        <img 
          src={heroImage} 
          alt="Serrurier professionnel intervenant sur un cylindre de serrure à Villeurbanne" 
          className="w-full h-full object-cover"
          fetchPriority="high"
          decoding="async"
        />
      </div>
      
      {/* Overlay sombre pour lisibilité */}
      <div className="absolute inset-0 bg-black/50" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="flex justify-center mb-6 mt-8">
            <div className="inline-flex items-center gap-3 bg-orange-800 text-white px-8 py-4 rounded-full text-lg font-semibold">
              <Phone className="h-6 w-6" />
              Serrurier professionnel à Villeurbanne
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Serrurier d'urgence à Villeurbanne & Grand Lyon
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-white/90">
            Ouverture de porte, changement et réparation de serrure, service express 24h/7j.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" variant="default" className="text-lg px-8 py-6 gap-3" asChild>
              <a href="tel:0695220018">
                <Phone className="h-6 w-6" />
                Demander un dépannage
              </a>
            </Button>
            <Button 
              size="lg" 
              variant="secondary" 
              className="text-lg px-8 py-6 gap-3"
              onClick={() => setCallbackOpen(true)}
            >
              Demander un rappel
            </Button>
          </div>
        </div>

        <CallbackForm open={callbackOpen} onOpenChange={setCallbackOpen} />

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
              <Clock className="h-10 w-10 text-primary" />
              <h2 className="font-semibold text-lg">Intervention rapide</h2>
              <p className="text-sm text-white/80">24h/24 et 7j/7</p>
            </div>
            <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
              <Shield className="h-10 w-10 text-primary" />
              <h2 className="font-semibold text-lg">Serrurier certifié</h2>
              <p className="text-sm text-white/80">Professionnel qualifié</p>
            </div>
            <div className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
              <Zap className="h-10 w-10 text-primary" />
              <h2 className="font-semibold text-lg">Devis transparent</h2>
              <p className="text-sm text-white/80">Sans surprise</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
